import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router-dom';

import {Header} from 'semantic-ui-react';

import RedditList from './List';

class RedditContent extends Component {

    shouldComponentUpdate() {
        return false;
    }

    render() {
        // console.log('RedditContent render');
        const {route} = this.props;
        return <Switch>
            <Route component={RedditList} exact={true} path={`${route}/`}/>
            <Route component={RedditList} path={`${route}/r/:subreddit`}/>
            <Route>
                <Header as='h1'>Page Not Found on Reddit</Header>
            </Route>
        </Switch>;
    }
}

export default connect(({routes: {
        clientReddit
    }}) => ({route: clientReddit}))(RedditContent);


// WEBPACK FOOTER //
// ./src/apps/client-reddit/components/Content.js